const FinancialProductType = {
    LEASING: "OPERATIONAL_LEASING",
    NAJLEASING: "NAJLEASING",
    LEASING_ONLINE: "LEASING_ONLINE",
    CREDIT: "KREDYT",
    RENTAL: "RENTAL"
}

export default FinancialProductType;